import { jsx as o } from "react/jsx-runtime";
import n from "../AchievableLogo/index.js";
import s from "../Link/index.js";
const L = (r) => {
  const { className: t, CustomLink: e, href: i, to: m } = r;
  return /* @__PURE__ */ o(s, { className: t, CustomLink: e, href: i, to: m, children: /* @__PURE__ */ o(n, {}) });
};
export {
  L as default
};
